import classnames from 'classnames/bind'
import { useRouter } from 'next/router'
import { useTranslate } from 'react-polyglot'
import { GlobalThemeColors } from '~/@types/colors'
import { GlobalGridPreset } from '~/@types/grid-preset'
import { GlobalTextPreset } from '~/@types/text-preset'
import { GlobalTextStyling } from '~/@types/text-styling'

import Slider, { useSliderState } from '@unlikelystudio/react-slider'

import { ArrowLeftIcon, ArrowRightIcon } from '~/components/Icons'
import InlineCta from '~/components/UI/InlineCta'
import { LinkProps } from '~/components/UI/Link'

import { useStyle } from '~/providers/StyleProvider'

import { GENERAL } from '~/data/dictionary'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export interface CategoryNavigationProps {
  className?: string
  links?: LinkProps[]
}

function CategoryNavigation({ className, links }: CategoryNavigationProps) {
  const gridStyle = useStyle({ grid: GlobalGridPreset.BASE_GRID })
  const t = useTranslate()

  const [{ prevSlide, nextSlide }, setSliderState] = useSliderState()
  const router = useRouter()

  const orderedLinks = links?.sort((a) => {
    const isActive = a?.href === `/${router?.locale}${router.asPath}`

    if (isActive) {
      return -1
    } else {
      return 0
    }
  })

  return links?.length > 0 ? (
    <div className={cx(css.CategoryNavigation, gridStyle, className)}>
      <div className={css.sliderWrapper}>
        <button
          className={cx(css.button, css.buttonPrev)}
          onClick={prevSlide}
          aria-label={t(GENERAL.SLIDER_BUTTON_LEFT)}>
          <ArrowLeftIcon className={css.icon} />
        </button>
        <Slider
          snap
          infinite
          setSliderState={setSliderState}
          className={css.sliderItem}
          containerClassName={css.slider}>
          {orderedLinks?.map((link, index) => {
            const isActive = link?.href === `/${router.locale}${router.asPath}`

            return (
              <InlineCta
                theme={GlobalThemeColors.Black}
                textPreset={GlobalTextPreset.Cta12Haffer}
                textStyling={GlobalTextStyling.UpperCase}
                lineProps={{
                  initialLineState: isActive ? 'underlined' : 'none',
                }}
                key={`link_${index}`}
                className={cx(css.link, {})}
                {...link}
              />
            )
          })}
        </Slider>
        <button
          className={cx(css.button, css.buttonNext)}
          onClick={nextSlide}
          aria-label={t(GENERAL.SLIDER_BUTTON_RIGHT)}>
          <ArrowRightIcon className={css.icon} />
        </button>
      </div>
    </div>
  ) : null
}

export default CategoryNavigation
